<mat-form-field appearance="outline" [class.has-value]="hasValue">
  <mat-label>{{ label }}</mat-label>
  @if (autosize) {
    <textarea
      matInput
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="rows"
      [cdkAutosizeMaxRows]="maxRows ?? null"
      [formControl]="control"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [autocomplete]="autocomplete"
      [cols]="cols"
      [name]="control.name"
      [attr.maxlength]="maxlength ?? null"
    ></textarea>
  } @else {
    <textarea
      matInput
      [formControl]="control"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [autocomplete]="autocomplete"
      [rows]="rows"
      [cols]="cols"
      [name]="control.name"
      [attr.maxlength]="maxlength ?? null"
    ></textarea>
  }
  @if (control?.invalid && control?.errors) {
    <mat-error>{{ errorLabel }}</mat-error>
  }
</mat-form-field>
